import { Component, Input, OnInit } from '@angular/core';
import { ManualRefundRequirementResponse, EventResponse } from '../../../../../../../../@shared/models/response.module';
import { EventsService } from '../../../../../../../../@shared/services/events-service';
import { ToastService } from '../../../../../../../../@core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-refunds-list',
  standalone: false,
  templateUrl: './manual-refunds-list.html',
  styleUrl: './manual-refunds-list.css'
})
export class ManualRefundsList implements OnInit {
  @Input() event: EventResponse;

  refunds: ManualRefundRequirementResponse[] = [];
  loading = false;
  filter: 'all' | 'pending' | 'completed' = 'all';
  processingId: number | null = null;

  constructor(
    private eventsService: EventsService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.loadRefunds();
  }

  loadRefunds() {
    if (!this.event?.event_id) return;

    this.loading = true;
    this.eventsService.getManualRefunds(this.event.event_id).subscribe({
      next: (data: ManualRefundRequirementResponse[]) => {
        this.refunds = data;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.toastService.error(err?.error?.reason || this.translateService.instant('common.error'));
      }
    });
  }

  get filteredRefunds(): ManualRefundRequirementResponse[] {
    if (this.filter === 'all') {
      return this.refunds;
    }
    return this.refunds.filter(r => r.status === this.filter);
  }

  get pendingCount(): number {
    return this.refunds.filter(r => r.status === 'pending').length;
  }

  get completedCount(): number {
    return this.refunds.filter(r => r.status === 'completed').length;
  }

  formatAmount(cents: number): string {
    return (cents / 100).toFixed(2);
  }

  getReasonLabel(reason: string): string {
    switch (reason) {
      case 'no_stripe_payment':
        return this.translateService.instant('manageEvent.manualRefunds.noStripePayment');
      case 'refund_failed':
        return this.translateService.instant('manageEvent.manualRefunds.refundFailed');
      default:
        return reason;
    }
  }

  markComplete(refund: ManualRefundRequirementResponse) {
    this.processingId = refund.requirement_id;

    this.eventsService.completeManualRefund(refund.requirement_id).subscribe({
      next: () => {
        this.processingId = null;
        this.toastService.success(this.translateService.instant('manageEvent.manualRefunds.markedComplete'));
        this.loadRefunds();
      },
      error: (err) => {
        this.processingId = null;
        this.toastService.error(err?.error?.reason || this.translateService.instant('common.error'));
      }
    });
  }
}
